import React, { useState, useMemo } from 'react';
import Card from '../../../ui/Card';
import { ICONS } from '../../../ui/icon-map';
import EmptyState from '../../../ui/EmptyState';
import DrillDownModal from '../components/DrillDownModal';
import ShareRow from '../components/ShareRow';

const ContractsKPIs = ({ data }) => {
    const [modal, setModal] = useState({ open: false, title: '', data: [] });

    const stats = useMemo(() => {
        const typeCounts = {};
        const customerCounts = {};
        
        data.forEach(item => {
            const type = item.type || 'Other';
            typeCounts[type] = (typeCounts[type] || 0) + 1;
            
            const cust = (item.customer || 'Unknown').trim();
            customerCounts[cust] = (customerCounts[cust] || 0) + 1;
        });

        const topCustomers = Object.entries(customerCounts)
            .sort((a,b) => b[1] - a[1])
            .slice(0, 5); 

        return {
            typeMix: Object.entries(typeCounts).sort((a,b) => b[1] - a[1]),
            topCustomers: topCustomers,
            total: data.length
        };
    }, [data]);

    return (
        <div className="flex flex-col gap-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

                <Card title="Contract Type Mix">
                    <div className="space-y-2">
                        {stats.typeMix.map(([type, count]) => {
                            const pct = stats.total > 0 ? Math.round((count / stats.total) * 100) : 0;
                            return (
                                <ShareRow
                                    key={type}
                                    label={type}
                                    sub={`${count} Contracts`}
                                    percent={pct}
                                    barWidth={pct}
                                    onClick={() => setModal({
                                        open: true,
                                        title: `${type} Contracts`,
                                        data: data.filter(i => i.type === type)
                                    })}
                                />
                            );
                        })}
                        {stats.typeMix.length === 0 && (
                            <EmptyState icon={ICONS.contracts} title="No data available" />
                        )}
                    </div>
                </Card>

                <Card title="Top Customers" subtitle="Most contracts opened in the period">
                    <div className="flex flex-col gap-1 overflow-y-auto pr-1 max-h-[300px]">
                        {stats.topCustomers.map(([customer, count], i) => {
                            // Relative percentage (leaderboard style) for Top Customers
                            // because individual counts are too small compared to total to show as %
                            const maxCount = stats.topCustomers[0]?.[1] || 1;
                            const relativePct = (count / maxCount) * 100;

                            return (
                                <ShareRow
                                    key={customer}
                                    rank={i + 1}
                                    label={customer}
                                    title={customer}
                                    value={count}
                                    barWidth={relativePct}
                                    onClick={() => setModal({
                                        open: true,
                                        title: `Contracts for ${customer}`,
                                        data: data.filter(i => (i.customer || '').trim() === customer)
                                    })}
                                />
                            );
                        })}
                        {stats.topCustomers.length === 0 && (
                            <EmptyState icon={ICONS.users} title="No data available" />
                        )}
                    </div>
                </Card>

            </div>

            <DrillDownModal
                isOpen={modal.open}
                onClose={() => setModal({ ...modal, open: false })}
                title={modal.title}
                data={modal.data}
            />
        </div>
    );
};

export default ContractsKPIs;
